/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-31 16:06:43
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-01 09:38:27
 */
/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:55:36
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-08 16:15:38
 */
import req from "@/utils/request";

// 变量分组列表
export const add = (params) => req.post("/site-service/m/site/linksGroup/add", params);
export const list = (params) => req.post("/site-service/m/site/linksGroup/list", params);
export const update = (params) => req.post("/site-service/m/site/linksGroup/update", params);
export const del = (params) => req.post("/site-service/m/site/linksGroup/del", params);
export const addLinks = (params) => req.post("/site-service/m/site/links/add", params);
export const listLinks = (params) => req.post("/site-service/m/site/links/list", params);
export const updateSort = (params) => req.post("/site-service/m/site/links/updateSort", params);
export const updateLink = (params) => req.post("/site-service/m/site/links/update", params);
export const delLink = (params) => req.post("/site-service/m/site/links/del", params);
export const delBatch = (params) => req.post("/site-service/m/site/links/delBatch", params);
